import AddIcon from '@mui/icons-material/Add';
import { Box, styled } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { hqRoutes } from 'hq/Routes';
import { useHqRelativePath } from 'hq/hooks/useHqRelativePath';
import { LwButton, Toolbox } from 'redesign';
import { invariant } from 'shared/utils/utils';
import { RenderUnsettledUI } from 'shared/components';
import { PartnerRelationsTableProvider } from './partner-relations-table-provider';
import { PartnerPage } from '../partner-page';
import { useGetPartner } from '../../partners/hooks/use-get-partner';

export const PartnerRelations = () => {
  const generatePath = useHqRelativePath();
  const { id } = useParams<'id'>();
  invariant(id);
  const partnerQuery = useGetPartner(id);
  const { t } = useTranslation('hq-screen-specific');

  if (partnerQuery.status !== 'success') {
    return <RenderUnsettledUI data={partnerQuery} />;
  }

  return (
    <PartnerPage>
      <StyledBox>
        <Toolbox upperDivider={false}>
          <LwButton
            to={generatePath(hqRoutes.PartnerRelationCreate, { id })}
            startIcon={<AddIcon />}
            iconColorMode="fill"
            color="primary"
            disabled={partnerQuery.data.deactivated}
          >
            {t('partners.relations.add_branch')}
          </LwButton>
        </Toolbox>
        <PartnerRelationsTableProvider partnerId={id} deactivated={partnerQuery.data.deactivated} />
      </StyledBox>
    </PartnerPage>
  );
};

const StyledBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
}));
